import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromCompare from '../reducers/compare.reducer';

export const getCompareState = createSelector(
  fromFeature.getProductsState,
  (state: fromFeature.DashboardState) => state.compare
);

export const getCompare = createSelector(getCompareState, fromCompare.getCompare);
export const getCompareLoaded = createSelector(getCompareState, fromCompare.getCompareLoaded);
